import { n as k } from "./property-9daa16cd.mjs";
import { r as rt } from "./state-7560d4dc.mjs";
import { r as st } from "./query-async-a940115b.mjs";
import { b as we, i as ot, E as ct, x as y, a as T, r as dt } from "./createReactComponent-58f9bea8.mjs";
import { e as M } from "./class-map-2994e95e.mjs";
import { o as lt } from "./if-defined-47693dfa.mjs";
import { S as ht } from "./slot-controller-fa97ce97.mjs";
import { r as ut } from "./icon-c572aa57.mjs";
import { r as pt } from "./icon-button-87ac6b5d.mjs";
import { a as ft } from "./menu-item-group-4d9c93fd.mjs";
import { r as gt } from "./button-7600b6ca.mjs";
import { r as mt } from "./tooltip-cb602d1f.mjs";
import { r as kt } from "./pill-5555e08e.mjs";
function me(i) {
  return i[i.length - 1];
}
function U(i, ...e) {
  return e.forEach((t) => {
    i.includes(t) || i.push(t);
  }), i;
}
function _e(i, e) {
  return i ? i.split(e) : [];
}
function ke(i, e, t) {
  return (e === void 0 || i >= e) && (t === void 0 || i <= t);
}
function We(i, e, t) {
  return i < e ? e : i > t ? t : i;
}
function V(i, e, t = {}, a = 0, n = "") {
  n += `<${Object.keys(t).reduce((s, o) => {
    let d = t[o];
    return typeof d == "function" && (d = d(a)), `${s} ${o}="${d}"`;
  }, i)}></${i}>`;
  const r = a + 1;
  return r < e ? V(i, e, t, r, n) : n;
}
function be(i) {
  return i.replace(/>\s+/g, ">").replace(/\s+</, "<");
}
function fe(i) {
  return new Date(i).setHours(0, 0, 0, 0);
}
function F() {
  return (/* @__PURE__ */ new Date()).setHours(0, 0, 0, 0);
}
function R(...i) {
  switch (i.length) {
    case 0:
      return F();
    case 1:
      return fe(i[0]);
  }
  const e = /* @__PURE__ */ new Date(0);
  return e.setFullYear(...i), e.setHours(0, 0, 0, 0);
}
function j(i, e) {
  const t = new Date(i);
  return t.setDate(t.getDate() + e);
}
function Q(i, e) {
  const t = new Date(i), a = t.getMonth() + e;
  let n = a % 12;
  n < 0 && (n += 12);
  const r = t.setMonth(a);
  return t.getMonth() !== n ? t.setDate(0) : r;
}
function K(i, e) {
  const t = new Date(i), a = t.getMonth(), n = t.setFullYear(t.getFullYear() + e);
  return a === 1 && t.getMonth() === 2 ? t.setDate(0) : n;
}
function Ce(i, e) {
  return (i - e + 7) % 7;
}
function N(i, e, t = 0) {
  const a = new Date(i).getDay();
  return j(i, Ce(e, t) - Ce(a, t));
}
function ze(i, e) {
  return Math.round((i - e) / 6048e5) + 1;
}
function bt(i) {
  const e = N(i, 4, 1);
  return ze(e, N(new Date(e).setMonth(0, 4), 4, 1));
}
function Ye(i, e) {
  const t = N(new Date(i).setMonth(0, 1), e, e), a = N(i, e, e), n = ze(a, t);
  return n < 53 ? n : a === N(new Date(i).setDate(32), e, e) ? 1 : n;
}
function yt(i) {
  return Ye(i, 0);
}
function vt(i) {
  return Ye(i, 6);
}
function B(i, e) {
  const t = new Date(i).getFullYear();
  return Math.floor(t / e) * e;
}
function $(i, e, t) {
  if (e !== 1 && e !== 2)
    return i;
  const a = new Date(i);
  return e === 1 ? t ? a.setMonth(a.getMonth() + 1, 0) : a.setDate(1) : t ? a.setFullYear(a.getFullYear() + 1, 0, 0) : a.setMonth(0, 1), a.setHours(0, 0, 0, 0);
}
const ge = /dd?|DD?|mm?|MM?|yy?(?:yy)?/, xt = /[\s!-/:-@[-`{-~年月日]+/;
let se = {};
const Se = { y: (i, e) => new Date(i).setFullYear(parseInt(e, 10)), m(i, e, t) {
  const a = new Date(i);
  let n = parseInt(e, 10) - 1;
  if (isNaN(n)) {
    if (!e)
      return NaN;
    const r = e.toLowerCase(), s = (o) => o.toLowerCase().startsWith(r);
    if (n = t.monthsShort.findIndex(s), n < 0 && (n = t.months.findIndex(s)), n < 0)
      return NaN;
  }
  return a.setMonth(n), a.getMonth() !== He(n) ? a.setDate(0) : a.getTime();
}, d: (i, e) => new Date(i).setDate(parseInt(e, 10)) }, Dt = { d: (i) => i.getDate(), dd: (i) => J(i.getDate(), 2), D: (i, e) => e.daysShort[i.getDay()], DD: (i, e) => e.days[i.getDay()], m: (i) => i.getMonth() + 1, mm: (i) => J(i.getMonth() + 1, 2), M: (i, e) => e.monthsShort[i.getMonth()], MM: (i, e) => e.months[i.getMonth()], y: (i) => i.getFullYear(), yy: (i) => J(i.getFullYear(), 2).slice(-2), yyyy: (i) => J(i.getFullYear(), 4) };
function He(i) {
  return i > -1 ? i % 12 : He(i + 12);
}
function J(i, e) {
  return i.toString().padStart(e, "0");
}
function je(i) {
  if (typeof i != "string")
    throw new Error("Invalid date format.");
  if (i in se)
    return se[i];
  const e = i.split(ge), t = i.match(new RegExp(ge, "g"));
  if (e.length === 0 || !t)
    throw new Error("Invalid date format.");
  const a = t.map((r) => Dt[r]), n = Object.keys(Se).reduce((r, s) => (t.find((o) => o[0] !== "D" && o[0].toLowerCase() === s) && r.push(s), r), []);
  return se[i] = { parser(r, s) {
    const o = r.split(xt).reduce((d, c, l) => {
      if (c.length > 0 && t[l]) {
        const u = t[l][0];
        u === "M" ? d.m = c : u !== "D" && (d[u] = c);
      }
      return d;
    }, {});
    return n.reduce((d, c) => {
      const l = Se[c](d, o[c], s);
      return isNaN(l) ? d : l;
    }, F());
  }, formatter: (r, s) => a.reduce((o, d, c) => o + `${e[c]}${d(r, s)}`, "") + me(e) };
}
function I(i, e, t) {
  if (i instanceof Date || typeof i == "number") {
    const a = fe(i);
    return isNaN(a) ? void 0 : a;
  }
  if (i) {
    if (i === "today")
      return F();
    if (e && e.toValue) {
      const a = e.toValue(i, e, t);
      return isNaN(a) ? void 0 : fe(a);
    }
    return je(e).parser(i, t);
  }
}
function q(i, e, t) {
  if (isNaN(i) || !i && i !== 0)
    return "";
  const a = typeof i == "number" ? new Date(i) : i;
  return e.toDisplay ? e.toDisplay(a, e, t) : je(e).formatter(a, t);
}
const wt = document.createRange();
function O(i) {
  return wt.createContextualFragment(i);
}
function Ke(i) {
  return i.parentElement || (i.parentNode instanceof ShadowRoot ? i.parentNode.host : void 0);
}
function ne(i) {
  return i.getRootNode().activeElement === i;
}
function Y(i) {
  i.style.display !== "none" && (i.style.display && (i.dataset.styleDisplay = i.style.display), i.style.display = "none");
}
function H(i) {
  i.style.display === "none" && (i.dataset.styleDisplay ? (i.style.display = i.dataset.styleDisplay, delete i.dataset.styleDisplay) : i.style.display = "");
}
function Z(i) {
  i.firstChild && (i.removeChild(i.firstChild), Z(i));
}
const ee = /* @__PURE__ */ new WeakMap(), { addEventListener: _t, removeEventListener: Ct } = EventTarget.prototype;
function te(i, e) {
  let t = ee.get(i);
  t || (t = [], ee.set(i, t)), e.forEach((a) => {
    _t.call(...a), t.push(a);
  });
}
function Ue(i) {
  let e = ee.get(i);
  e && (e.forEach((t) => {
    Ct.call(...t);
  }), ee.delete(i));
}
if (!Event.prototype.composedPath) {
  const i = (e, t = []) => {
    let a;
    return t.push(e), e.parentNode ? a = e.parentNode : e.host ? a = e.host : e.defaultView && (a = e.defaultView), a ? i(a, t) : t;
  };
  Event.prototype.composedPath = function() {
    return i(this.target);
  };
}
function qe(i, e, t) {
  const [a, ...n] = i;
  return e(a) ? a : a !== t && a.tagName !== "HTML" && n.length !== 0 ? qe(n, e, t) : void 0;
}
function Je(i, e) {
  const t = typeof e == "function" ? e : (a) => a instanceof Element && a.matches(e);
  return qe(i.composedPath(), t, i.currentTarget);
}
const W = { en: { days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], daysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], daysMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"], months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"], monthsShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], today: "Today", clear: "Clear", titleFormat: "MM y" } }, ye = { autohide: !1, beforeShowDay: null, beforeShowDecade: null, beforeShowMonth: null, beforeShowYear: null, clearButton: !1, dateDelimiter: ",", datesDisabled: [], daysOfWeekDisabled: [], daysOfWeekHighlighted: [], defaultViewDate: void 0, disableTouchKeyboard: !1, enableOnReadonly: !0, format: "mm/dd/yyyy", language: "en", maxDate: null, maxNumberOfDates: 1, maxView: 3, minDate: null, nextArrow: "»", orientation: "auto", pickLevel: 0, prevArrow: "«", showDaysOfWeek: !0, showOnClick: !0, showOnFocus: !0, startView: 0, title: "", todayButton: !1, todayButtonMode: 0, todayHighlight: !1, updateOnBlur: !0, weekNumbers: 0, weekStart: 0 }, { language: oe, format: St, weekStart: Pt } = ye;
function Pe(i, e) {
  return i.length < 6 && e >= 0 && e < 7 ? U(i, e) : i;
}
function Xe(i, e) {
  switch (i === 4 ? e === 6 ? 3 : !e + 1 : i) {
    case 1:
      return bt;
    case 2:
      return yt;
    case 3:
      return vt;
  }
}
function Me(i, e, t) {
  return e.weekStart = i, e.weekEnd = (i + 6) % 7, t === 4 && (e.getWeekNumber = Xe(4, i)), i;
}
function Ee(i, e, t, a) {
  const n = I(i, e, t);
  return n !== void 0 ? n : a;
}
function ce(i, e, t = 3) {
  const a = parseInt(i, 10);
  return a >= 0 && a <= t ? a : e;
}
function X(i, e, t, a = void 0) {
  e in i && (t in i || (i[t] = a ? a(i[e]) : i[e]), delete i[e]);
}
function de(i, e) {
  const t = Object.assign({}, i), a = {}, n = e.constructor.locales, r = !!e.rangeSideIndex;
  let { datesDisabled: s, format: o, language: d, locale: c, maxDate: l, maxView: u, minDate: w, pickLevel: f, startView: x, weekNumbers: p, weekStart: D } = e.config || {};
  if (X(t, "calendarWeeks", "weekNumbers", (h) => h ? 1 : 0), X(t, "clearBtn", "clearButton"), X(t, "todayBtn", "todayButton"), X(t, "todayBtnMode", "todayButtonMode"), t.language) {
    let h;
    if (t.language !== d && (n[t.language] ? h = t.language : (h = t.language.split("-")[0], n[h] || (h = !1))), delete t.language, h) {
      d = a.language = h;
      const b = c || n[oe];
      c = Object.assign({ format: St, weekStart: Pt }, n[oe]), d !== oe && Object.assign(c, n[d]), a.locale = c, o === b.format && (o = a.format = c.format), D === b.weekStart && (D = Me(c.weekStart, a, p));
    }
  }
  if (t.format) {
    const h = typeof t.format.toDisplay == "function", b = typeof t.format.toValue == "function", v = ge.test(t.format);
    (h && b || v) && (o = a.format = t.format), delete t.format;
  }
  let S = f;
  "pickLevel" in t && (S = ce(t.pickLevel, f, 2), delete t.pickLevel), S !== f && (S > f && ("minDate" in t || (t.minDate = w), "maxDate" in t || (t.maxDate = l)), s && !t.datesDisabled && (t.datesDisabled = []), f = a.pickLevel = S);
  let P = w, _ = l;
  if ("minDate" in t) {
    const h = R(0, 0, 1);
    P = t.minDate === null ? h : Ee(t.minDate, o, c, P), P !== h && (P = $(P, f, !1)), delete t.minDate;
  }
  if ("maxDate" in t && (_ = t.maxDate === null ? void 0 : Ee(t.maxDate, o, c, _), _ !== void 0 && (_ = $(_, f, !0)), delete t.maxDate), _ < P ? (w = a.minDate = _, l = a.maxDate = P) : (w !== P && (w = a.minDate = P), l !== _ && (l = a.maxDate = _)), t.datesDisabled) {
    const h = t.datesDisabled;
    if (typeof h == "function")
      a.datesDisabled = null, a.checkDisabled = (b, v) => h(new Date(b), v, r);
    else {
      const b = a.datesDisabled = h.reduce((v, re) => {
        const De = I(re, o, c);
        return De !== void 0 ? U(v, $(De, f, r)) : v;
      }, []);
      a.checkDisabled = (v) => b.includes(v);
    }
    delete t.datesDisabled;
  }
  if ("defaultViewDate" in t) {
    const h = I(t.defaultViewDate, o, c);
    h !== void 0 && (a.defaultViewDate = h), delete t.defaultViewDate;
  }
  if ("weekStart" in t) {
    const h = Number(t.weekStart) % 7;
    isNaN(h) || (D = Me(h, a, p)), delete t.weekStart;
  }
  if (t.daysOfWeekDisabled && (a.daysOfWeekDisabled = t.daysOfWeekDisabled.reduce(Pe, []), delete t.daysOfWeekDisabled), t.daysOfWeekHighlighted && (a.daysOfWeekHighlighted = t.daysOfWeekHighlighted.reduce(Pe, []), delete t.daysOfWeekHighlighted), "weekNumbers" in t) {
    let h = t.weekNumbers;
    if (h) {
      const b = typeof h == "function" ? (v, re) => h(new Date(v), re) : Xe(h = parseInt(h, 10), D);
      b && (p = a.weekNumbers = h, a.getWeekNumber = b);
    } else
      p = a.weekNumbers = 0, a.getWeekNumber = null;
    delete t.weekNumbers;
  }
  if ("maxNumberOfDates" in t) {
    const h = parseInt(t.maxNumberOfDates, 10);
    h >= 0 && (a.maxNumberOfDates = h, a.multidate = h !== 1), delete t.maxNumberOfDates;
  }
  t.dateDelimiter && (a.dateDelimiter = String(t.dateDelimiter), delete t.dateDelimiter);
  let E = u;
  "maxView" in t && (E = ce(t.maxView, u), delete t.maxView), E = f > E ? f : E, E !== u && (u = a.maxView = E);
  let C = x;
  if ("startView" in t && (C = ce(t.startView, C), delete t.startView), C < f ? C = f : C > u && (C = u), C !== x && (a.startView = C), t.prevArrow) {
    const h = O(t.prevArrow);
    h.childNodes.length > 0 && (a.prevArrow = h.childNodes), delete t.prevArrow;
  }
  if (t.nextArrow) {
    const h = O(t.nextArrow);
    h.childNodes.length > 0 && (a.nextArrow = h.childNodes), delete t.nextArrow;
  }
  if ("disableTouchKeyboard" in t && (a.disableTouchKeyboard = "ontouchstart" in document && !!t.disableTouchKeyboard, delete t.disableTouchKeyboard), t.orientation) {
    const h = t.orientation.toLowerCase().split(/\s+/g);
    a.orientation = { x: h.find((b) => b === "left" || b === "right") || "auto", y: h.find((b) => b === "top" || b === "bottom") || "auto" }, delete t.orientation;
  }
  if ("todayButtonMode" in t) {
    switch (t.todayButtonMode) {
      case 0:
      case 1:
        a.todayButtonMode = t.todayButtonMode;
    }
    delete t.todayButtonMode;
  }
  return Object.entries(t).forEach(([h, b]) => {
    b !== void 0 && h in ye && (a[h] = b);
  }), a;
}
const Oe = { show: { key: "ArrowDown" }, hide: null, toggle: { key: "Escape" }, prevButton: { key: "ArrowLeft", ctrlOrMetaKey: !0 }, nextButton: { key: "ArrowRight", ctrlOrMetaKey: !0 }, viewSwitch: { key: "ArrowUp", ctrlOrMetaKey: !0 }, clearButton: { key: "Backspace", ctrlOrMetaKey: !0 }, todayButton: { key: ".", ctrlOrMetaKey: !0 }, exitEditMode: { key: "ArrowDown", ctrlOrMetaKey: !0 } }, $e = (i) => i.map((e) => `<button type="button" class="%buttonClass% ${e}" tabindex="-1"></button>`).join(""), Mt = be(`<div class="datepicker">
  <div class="datepicker-picker">
    <div class="datepicker-header">
      <div class="datepicker-title"></div>
      <div class="datepicker-controls">
        ${$e(["prev-button prev-btn", "view-switch", "next-button next-btn"])}
      </div>
    </div>
    <div class="datepicker-main"></div>
    <div class="datepicker-footer">
      <div class="datepicker-controls">
        ${$e(["today-button today-btn", "clear-button clear-btn"])}
      </div>
    </div>
  </div>
</div>`), Et = be(`<div class="days">
  <div class="days-of-week">${V("span", 7, { class: "dow" })}</div>
  <div class="datepicker-grid">${V("span", 42)}</div>
</div>`), Ot = be(`<div class="week-numbers calendar-weeks">
  <div class="days-of-week"><span class="dow"></span></div>
  <div class="weeks">${V("span", 6, { class: "week" })}</div>
</div>`);
class ve {
  constructor(e, t) {
    Object.assign(this, t, { picker: e, element: O('<div class="datepicker-view"></div>').firstChild, selected: [], isRangeEnd: !!e.datepicker.rangeSideIndex }), this.init(this.picker.datepicker.config);
  }
  init(e) {
    "pickLevel" in e && (this.isMinView = this.id === e.pickLevel), this.setOptions(e), this.updateFocus(), this.updateSelection();
  }
  prepareForRender(e, t, a) {
    this.disabled = [];
    const n = this.picker;
    n.setViewSwitchLabel(e), n.setPrevButtonDisabled(t), n.setNextButtonDisabled(a);
  }
  setDisabled(e, t) {
    t.add("disabled"), U(this.disabled, e);
  }
  performBeforeHook(e, t) {
    let a = this.beforeShow(new Date(t));
    switch (typeof a) {
      case "boolean":
        a = { enabled: a };
        break;
      case "string":
        a = { classes: a };
    }
    if (a) {
      const n = e.classList;
      if (a.enabled === !1 && this.setDisabled(t, n), a.classes) {
        const r = a.classes.split(/\s+/);
        n.add(...r), r.includes("disabled") && this.setDisabled(t, n);
      }
      a.content && function(r, s) {
        Z(r), s instanceof DocumentFragment ? r.appendChild(s) : typeof s == "string" ? r.appendChild(O(s)) : typeof s.forEach == "function" && s.forEach((o) => {
          r.appendChild(o);
        });
      }(e, a.content);
    }
  }
  renderCell(e, t, a, n, { selected: r, range: s }, o, d = []) {
    e.textContent = t, this.isMinView && (e.dataset.date = n);
    const c = e.classList;
    if (e.className = `datepicker-cell ${this.cellClass}`, a < this.first ? c.add("prev") : a > this.last && c.add("next"), c.add(...d), (o || this.checkDisabled(n, this.id)) && this.setDisabled(n, c), s) {
      const [l, u] = s;
      a > l && a < u && c.add("range"), a === l && c.add("range-start"), a === u && c.add("range-end");
    }
    r.includes(a) && c.add("selected"), a === this.focused && c.add("focused"), this.beforeShow && this.performBeforeHook(e, n);
  }
  refreshCell(e, t, a, [n, r]) {
    const s = e.classList;
    s.remove("range", "range-start", "range-end", "selected", "focused"), t > n && t < r && s.add("range"), t === n && s.add("range-start"), t === r && s.add("range-end"), a.includes(t) && s.add("selected"), t === this.focused && s.add("focused");
  }
  changeFocusedCell(e) {
    this.grid.querySelectorAll(".focused").forEach((t) => {
      t.classList.remove("focused");
    }), this.grid.children[e].classList.add("focused");
  }
}
class $t extends ve {
  constructor(e) {
    super(e, { id: 0, name: "days", cellClass: "day" });
  }
  init(e, t = !0) {
    if (t) {
      const a = O(Et).firstChild;
      this.dow = a.firstChild, this.grid = a.lastChild, this.element.appendChild(a);
    }
    super.init(e);
  }
  setOptions(e) {
    let t;
    if ("minDate" in e && (this.minDate = e.minDate), "maxDate" in e && (this.maxDate = e.maxDate), e.checkDisabled && (this.checkDisabled = e.checkDisabled), e.daysOfWeekDisabled && (this.daysOfWeekDisabled = e.daysOfWeekDisabled, t = !0), e.daysOfWeekHighlighted && (this.daysOfWeekHighlighted = e.daysOfWeekHighlighted), "todayHighlight" in e && (this.todayHighlight = e.todayHighlight), "weekStart" in e && (this.weekStart = e.weekStart, this.weekEnd = e.weekEnd, t = !0), e.locale) {
      const a = this.locale = e.locale;
      this.dayNames = a.daysMin, this.switchLabelFormat = a.titleFormat, t = !0;
    }
    if ("beforeShowDay" in e && (this.beforeShow = typeof e.beforeShowDay == "function" ? e.beforeShowDay : void 0), "weekNumbers" in e)
      if (e.weekNumbers && !this.weekNumbers) {
        const a = O(Ot).firstChild;
        this.weekNumbers = { element: a, dow: a.firstChild, weeks: a.lastChild }, this.element.insertBefore(a, this.element.firstChild);
      } else
        this.weekNumbers && !e.weekNumbers && (this.element.removeChild(this.weekNumbers.element), this.weekNumbers = null);
    "getWeekNumber" in e && (this.getWeekNumber = e.getWeekNumber), "showDaysOfWeek" in e && (e.showDaysOfWeek ? (H(this.dow), this.weekNumbers && H(this.weekNumbers.dow)) : (Y(this.dow), this.weekNumbers && Y(this.weekNumbers.dow))), t && Array.from(this.dow.children).forEach((a, n) => {
      const r = (this.weekStart + n) % 7;
      a.textContent = this.dayNames[r], a.className = this.daysOfWeekDisabled.includes(r) ? "dow disabled" : "dow";
    });
  }
  updateFocus() {
    const e = new Date(this.picker.viewDate), t = e.getFullYear(), a = e.getMonth(), n = R(t, a, 1), r = N(n, this.weekStart, this.weekStart);
    this.first = n, this.last = R(t, a + 1, 0), this.start = r, this.focused = this.picker.viewDate;
  }
  updateSelection() {
    const { dates: e, rangepicker: t } = this.picker.datepicker;
    this.selected = e, t && (this.range = t.dates);
  }
  render() {
    if (this.today = this.todayHighlight ? F() : void 0, this.prepareForRender(q(this.focused, this.switchLabelFormat, this.locale), this.first <= this.minDate, this.last >= this.maxDate), this.weekNumbers) {
      const e = this.weekStart, t = N(this.first, e, e);
      Array.from(this.weekNumbers.weeks.children).forEach((a, n) => {
        const r = j(t, 7 * n);
        a.textContent = this.getWeekNumber(r, e), n > 3 && a.classList[r > this.last ? "add" : "remove"]("next");
      });
    }
    Array.from(this.grid.children).forEach((e, t) => {
      const a = j(this.start, t), n = new Date(a), r = n.getDay(), s = [];
      this.today === a && s.push("today"), this.daysOfWeekHighlighted.includes(r) && s.push("highlighted"), this.renderCell(e, n.getDate(), a, a, this, a < this.minDate || a > this.maxDate || this.daysOfWeekDisabled.includes(r), s);
    });
  }
  refresh() {
    const e = this.range || [];
    Array.from(this.grid.children).forEach((t) => {
      this.refreshCell(t, Number(t.dataset.date), this.selected, e);
    });
  }
  refreshFocus() {
    this.changeFocusedCell(Math.round((this.focused - this.start) / 864e5));
  }
}
function Ne(i, e) {
  if (!i || !i[0] || !i[1])
    return;
  const [[t, a], [n, r]] = i;
  return t > e || n < e ? void 0 : [t === e ? a : -1, n === e ? r : 12];
}
class Nt extends ve {
  constructor(e) {
    super(e, { id: 1, name: "months", cellClass: "month" });
  }
  init(e, t = !0) {
    t && (this.grid = this.element, this.element.classList.add("months", "datepicker-grid"), this.grid.appendChild(O(V("span", 12, { "data-month": (a) => a }))), this.first = 0, this.last = 11), super.init(e);
  }
  setOptions(e) {
    if (e.locale && (this.monthNames = e.locale.monthsShort), "minDate" in e)
      if (e.minDate === void 0)
        this.minYear = this.minMonth = this.minDate = void 0;
      else {
        const t = new Date(e.minDate);
        this.minYear = t.getFullYear(), this.minMonth = t.getMonth(), this.minDate = t.setDate(1);
      }
    if ("maxDate" in e)
      if (e.maxDate === void 0)
        this.maxYear = this.maxMonth = this.maxDate = void 0;
      else {
        const t = new Date(e.maxDate);
        this.maxYear = t.getFullYear(), this.maxMonth = t.getMonth(), this.maxDate = R(this.maxYear, this.maxMonth + 1, 0);
      }
    e.checkDisabled && (this.checkDisabled = this.isMinView || e.datesDisabled === null ? e.checkDisabled : () => !1), "beforeShowMonth" in e && (this.beforeShow = typeof e.beforeShowMonth == "function" ? e.beforeShowMonth : void 0);
  }
  updateFocus() {
    const e = new Date(this.picker.viewDate);
    this.year = e.getFullYear(), this.focused = e.getMonth();
  }
  updateSelection() {
    const { dates: e, rangepicker: t } = this.picker.datepicker;
    this.selected = e.reduce((a, n) => {
      const r = new Date(n), s = r.getFullYear(), o = r.getMonth();
      return a[s] === void 0 ? a[s] = [o] : U(a[s], o), a;
    }, {}), t && t.dates && (this.range = t.dates.map((a) => {
      const n = new Date(a);
      return isNaN(n) ? void 0 : [n.getFullYear(), n.getMonth()];
    }));
  }
  render() {
    this.prepareForRender(this.year, this.year <= this.minYear, this.year >= this.maxYear);
    const e = this.selected[this.year] || [], t = this.year < this.minYear || this.year > this.maxYear, a = this.year === this.minYear, n = this.year === this.maxYear, r = Ne(this.range, this.year);
    Array.from(this.grid.children).forEach((s, o) => {
      const d = $(new Date(this.year, o, 1), 1, this.isRangeEnd);
      this.renderCell(s, this.monthNames[o], o, d, { selected: e, range: r }, t || a && o < this.minMonth || n && o > this.maxMonth);
    });
  }
  refresh() {
    const e = this.selected[this.year] || [], t = Ne(this.range, this.year) || [];
    Array.from(this.grid.children).forEach((a, n) => {
      this.refreshCell(a, n, e, t);
    });
  }
  refreshFocus() {
    this.changeFocusedCell(this.focused);
  }
}
class Ie extends ve {
  constructor(e, t) {
    super(e, t);
  }
  init(e, t = !0) {
    var a;
    t && (this.navStep = 10 * this.step, this.beforeShowOption = `beforeShow${a = this.cellClass, [...a].reduce((n, r, s) => n + (s ? r : r.toUpperCase()), "")}`, this.grid = this.element, this.element.classList.add(this.name, "datepicker-grid"), this.grid.appendChild(O(V("span", 12)))), super.init(e);
  }
  setOptions(e) {
    if ("minDate" in e && (e.minDate === void 0 ? this.minYear = this.minDate = void 0 : (this.minYear = B(e.minDate, this.step), this.minDate = R(this.minYear, 0, 1))), "maxDate" in e && (e.maxDate === void 0 ? this.maxYear = this.maxDate = void 0 : (this.maxYear = B(e.maxDate, this.step), this.maxDate = R(this.maxYear, 11, 31))), e.checkDisabled && (this.checkDisabled = this.isMinView || e.datesDisabled === null ? e.checkDisabled : () => !1), this.beforeShowOption in e) {
      const t = e[this.beforeShowOption];
      this.beforeShow = typeof t == "function" ? t : void 0;
    }
  }
  updateFocus() {
    const e = new Date(this.picker.viewDate), t = B(e, this.navStep), a = t + 9 * this.step;
    this.first = t, this.last = a, this.start = t - this.step, this.focused = B(e, this.step);
  }
  updateSelection() {
    const { dates: e, rangepicker: t } = this.picker.datepicker;
    this.selected = e.reduce((a, n) => U(a, B(n, this.step)), []), t && t.dates && (this.range = t.dates.map((a) => {
      if (a !== void 0)
        return B(a, this.step);
    }));
  }
  render() {
    this.prepareForRender(`${this.first}-${this.last}`, this.first <= this.minYear, this.last >= this.maxYear), Array.from(this.grid.children).forEach((e, t) => {
      const a = this.start + t * this.step, n = $(new Date(a, 0, 1), 2, this.isRangeEnd);
      e.dataset.year = a, this.renderCell(e, a, a, n, this, a < this.minYear || a > this.maxYear);
    });
  }
  refresh() {
    const e = this.range || [];
    Array.from(this.grid.children).forEach((t) => {
      this.refreshCell(t, Number(t.textContent), this.selected, e);
    });
  }
  refreshFocus() {
    this.changeFocusedCell(Math.round((this.focused - this.start) / this.step));
  }
}
function A(i, e) {
  const t = { bubbles: !0, cancelable: !0, detail: { date: i.getDate(), viewDate: new Date(i.picker.viewDate), viewId: i.picker.currentView.id, datepicker: i } };
  i.element.dispatchEvent(new CustomEvent(e, t));
}
function ie(i, e) {
  const { config: t, picker: a } = i, { currentView: n, viewDate: r } = a;
  let s;
  switch (n.id) {
    case 0:
      s = Q(r, e);
      break;
    case 1:
      s = K(r, e);
      break;
    default:
      s = K(r, e * n.navStep);
  }
  s = We(s, t.minDate, t.maxDate), a.changeFocus(s).render();
}
function Ge(i) {
  const e = i.picker.currentView.id;
  e !== i.config.maxView && i.picker.changeView(e + 1).render();
}
function Qe(i) {
  i.setDate({ clear: !0 });
}
function Ze(i) {
  const e = F();
  i.config.todayButtonMode === 1 ? i.setDate(e, { forceRefresh: !0, viewDate: e }) : i.setFocusedDate(e, !0);
}
function et(i) {
  const e = () => {
    i.config.updateOnBlur ? i.update({ revert: !0 }) : i.refresh("input"), i.hide();
  }, t = i.element;
  ne(t) ? t.addEventListener("blur", e, { once: !0 }) : e();
}
function It(i) {
  Ge(i);
}
function Ft(i) {
  ie(i, -1);
}
function Bt(i) {
  ie(i, 1);
}
function Lt(i, e) {
  const t = Je(e, ".datepicker-cell");
  if (!t || t.classList.contains("disabled"))
    return;
  const { id: a, isMinView: n } = i.picker.currentView, r = t.dataset;
  n ? i.setDate(Number(r.date)) : function(s, o) {
    const d = s.picker, c = new Date(d.viewDate), l = d.currentView.id, u = l === 1 ? Q(c, o - c.getMonth()) : K(c, o - c.getFullYear());
    d.changeFocus(u).changeView(l - 1).render();
  }(i, Number(a === 1 ? r.month : r.year));
}
function At(i) {
  i.preventDefault();
}
const le = ["left", "top", "right", "bottom"].reduce((i, e) => (i[e] = `datepicker-orient-${e}`, i), {}), Fe = (i) => i && `${i}px`;
function Be(i, e) {
  if ("title" in e && (e.title ? (i.controls.title.textContent = e.title, H(i.controls.title)) : (i.controls.title.textContent = "", Y(i.controls.title))), e.prevArrow) {
    const t = i.controls.prevButton;
    Z(t), e.prevArrow.forEach((a) => {
      t.appendChild(a.cloneNode(!0));
    });
  }
  if (e.nextArrow) {
    const t = i.controls.nextButton;
    Z(t), e.nextArrow.forEach((a) => {
      t.appendChild(a.cloneNode(!0));
    });
  }
  if (e.locale && (i.controls.todayButton.textContent = e.locale.today, i.controls.clearButton.textContent = e.locale.clear), "todayButton" in e && (e.todayButton ? H(i.controls.todayButton) : Y(i.controls.todayButton)), "minDate" in e || "maxDate" in e) {
    const { minDate: t, maxDate: a } = i.datepicker.config;
    i.controls.todayButton.disabled = !ke(F(), t, a);
  }
  "clearButton" in e && (e.clearButton ? H(i.controls.clearButton) : Y(i.controls.clearButton));
}
function Le(i) {
  const { dates: e, config: t, rangeSideIndex: a } = i;
  return We(e.length > 0 ? me(e) : $(t.defaultViewDate, t.pickLevel, a), t.minDate, t.maxDate);
}
function Ae(i, e) {
  "_oldViewDate" in i || e === i.viewDate || (i._oldViewDate = i.viewDate), i.viewDate = e;
  const { id: t, year: a, first: n, last: r } = i.currentView, s = new Date(e).getFullYear();
  switch (t) {
    case 0:
      return e < n || e > r;
    case 1:
      return s !== a;
    default:
      return s < n || s > r;
  }
}
function he(i) {
  return window.getComputedStyle(i).direction;
}
function tt(i) {
  const e = Ke(i);
  if (e !== document.body && e)
    return window.getComputedStyle(e).overflow !== "visible" ? e : tt(e);
}
class Vt {
  constructor(e) {
    const { config: t, inputField: a } = this.datepicker = e, n = Mt.replace(/%buttonClass%/g, t.buttonClass), r = this.element = O(n).firstChild, [s, o, d] = r.firstChild.children, c = s.firstElementChild, [l, u, w] = s.lastElementChild.children, [f, x] = d.firstChild.children, p = { title: c, prevButton: l, viewSwitch: u, nextButton: w, todayButton: f, clearButton: x };
    this.main = o, this.controls = p;
    const D = a ? "dropdown" : "inline";
    r.classList.add(`datepicker-${D}`), Be(this, t), this.viewDate = Le(e), te(e, [[r, "mousedown", At], [o, "click", Lt.bind(null, e)], [p.viewSwitch, "click", It.bind(null, e)], [p.prevButton, "click", Ft.bind(null, e)], [p.nextButton, "click", Bt.bind(null, e)], [p.todayButton, "click", Ze.bind(null, e)], [p.clearButton, "click", Qe.bind(null, e)]]), this.views = [new $t(this), new Nt(this), new Ie(this, { id: 2, name: "years", cellClass: "year", step: 1 }), new Ie(this, { id: 3, name: "decades", cellClass: "decade", step: 10 })], this.currentView = this.views[t.startView], this.currentView.render(), this.main.appendChild(this.currentView.element), t.container ? t.container.appendChild(this.element) : a.after(this.element);
  }
  setOptions(e) {
    Be(this, e), this.views.forEach((t) => {
      t.init(e, !1);
    }), this.currentView.render();
  }
  detach() {
    this.element.remove();
  }
  show() {
    if (this.active)
      return;
    const { datepicker: e, element: t } = this, a = e.inputField;
    if (a) {
      const n = he(a);
      n !== he(Ke(t)) ? t.dir = n : t.dir && t.removeAttribute("dir"), this.place(), t.classList.add("active"), e.config.disableTouchKeyboard && a.blur();
    } else
      t.classList.add("active");
    this.active = !0, A(e, "show");
  }
  hide() {
    this.active && (this.datepicker.exitEditMode(), this.element.classList.remove("active"), this.active = !1, A(this.datepicker, "hide"));
  }
  place() {
    const { classList: e, style: t } = this.element;
    t.display = "block";
    const { width: a, height: n } = this.element.getBoundingClientRect(), r = this.element.offsetParent;
    t.display = "";
    const { config: s, inputField: o } = this.datepicker, { left: d, top: c, right: l, bottom: u, width: w, height: f } = o.getBoundingClientRect();
    let { x, y: p } = s.orientation, D = d, S = c;
    if (r !== document.body && r) {
      const v = r.getBoundingClientRect();
      D -= v.left - r.scrollLeft, S -= v.top - r.scrollTop;
    } else
      D += window.scrollX, S += window.scrollY;
    const P = tt(o);
    let _ = 0, E = 0, { clientWidth: C, clientHeight: h } = document.documentElement;
    if (P) {
      const v = P.getBoundingClientRect();
      v.top > 0 && (E = v.top), v.left > 0 && (_ = v.left), v.right < C && (C = v.right), v.bottom < h && (h = v.bottom);
    }
    let b = 0;
    x === "auto" && (d < _ ? (x = "left", b = _ - d) : d + a > C ? (x = "right", C < l && (b = C - l)) : x = he(o) === "rtl" ? l - a < _ ? "left" : "right" : "left"), x === "right" && (D += w - a), D += b, p === "auto" && (p = c - n > E && u + n > h ? "top" : "bottom"), p === "top" ? S -= n : S += f, e.remove(...Object.values(le)), e.add(le[x], le[p]), t.left = Fe(D), t.top = Fe(S);
  }
  setViewSwitchLabel(e) {
    this.controls.viewSwitch.textContent = e;
  }
  setPrevButtonDisabled(e) {
    this.controls.prevButton.disabled = e;
  }
  setNextButtonDisabled(e) {
    this.controls.nextButton.disabled = e;
  }
  changeView(e) {
    const t = this.currentView;
    return e !== t.id && (this._oldView || (this._oldView = t), this.currentView = this.views[e], this._renderMethod = "render"), this;
  }
  changeFocus(e) {
    return this._renderMethod = Ae(this, e) ? "render" : "refreshFocus", this.views.forEach((t) => {
      t.updateFocus();
    }), this;
  }
  update(e = void 0) {
    const t = e === void 0 ? Le(this.datepicker) : e;
    return this._renderMethod = Ae(this, t) ? "render" : "refresh", this.views.forEach((a) => {
      a.updateFocus(), a.updateSelection();
    }), this;
  }
  render(e = !0) {
    const { currentView: t, datepicker: a, _oldView: n } = this, r = new Date(this._oldViewDate), s = e && this._renderMethod || "render";
    if (delete this._oldView, delete this._oldViewDate, delete this._renderMethod, t[s](), n && (this.main.replaceChild(t.element, n.element), A(a, "changeView")), !isNaN(r)) {
      const o = new Date(this.viewDate);
      o.getFullYear() !== r.getFullYear() && A(a, "changeYear"), o.getMonth() !== r.getMonth() && A(a, "changeMonth");
    }
  }
}
function it(i, e, t, a, n, r) {
  if (ke(i, n, r))
    return a(i) ? it(e(i, t), e, t, a, n, r) : i;
}
function Rt(i, e, t) {
  const a = i.picker, n = a.currentView, r = n.step || 1;
  let s, o = a.viewDate;
  switch (n.id) {
    case 0:
      o = j(o, t ? 7 * e : e), s = j;
      break;
    case 1:
      o = Q(o, t ? 4 * e : e), s = Q;
      break;
    default:
      o = K(o, e * (t ? 4 : 1) * r), s = K;
  }
  o = it(o, s, e < 0 ? -r : r, (d) => n.disabled.includes(d), n.minDate, n.maxDate), o !== void 0 && a.changeFocus(o).render();
}
function Tt(i, e) {
  const { config: t, picker: a, editMode: n } = i, r = a.active, { key: s, altKey: o, shiftKey: d } = e, c = e.ctrlKey || e.metaKey, l = () => {
    e.preventDefault(), e.stopPropagation();
  };
  if (s === "Tab")
    return void et(i);
  if (s === "Enter") {
    if (r)
      if (n)
        i.exitEditMode({ update: !0, autohide: t.autohide });
      else {
        const p = a.currentView;
        p.isMinView ? i.setDate(a.viewDate) : (a.changeView(p.id - 1).render(), l());
      }
    else
      i.update();
    return;
  }
  const u = t.shortcutKeys, w = { key: s, ctrlOrMetaKey: c, altKey: o, shiftKey: d }, f = Object.keys(u).find((p) => {
    const D = u[p];
    return !Object.keys(D).find((S) => D[S] !== w[S]);
  });
  if (f) {
    let p;
    if (f === "toggle" ? p = f : n ? f === "exitEditMode" && (p = f) : r ? f === "hide" ? p = f : f === "prevButton" ? p = [ie, [i, -1]] : f === "nextButton" ? p = [ie, [i, 1]] : f === "viewSwitch" ? p = [Ge, [i]] : t.clearButton && f === "clearButton" ? p = [Qe, [i]] : t.todayButton && f === "todayButton" && (p = [Ze, [i]]) : f === "show" && (p = f), p)
      return Array.isArray(p) ? p[0].apply(null, p[1]) : i[p](), void l();
  }
  if (!r || n)
    return;
  const x = (p, D) => {
    d || c || o ? i.enterEditMode() : (Rt(i, p, D), e.preventDefault());
  };
  s === "ArrowLeft" ? x(-1, !1) : s === "ArrowRight" ? x(1, !1) : s === "ArrowUp" ? x(-1, !0) : s === "ArrowDown" ? x(1, !0) : (s === "Backspace" || s === "Delete" || s && s.length === 1 && !c) && i.enterEditMode();
}
function Wt(i) {
  i.config.showOnFocus && !i._showing && i.show();
}
function zt(i, e) {
  const t = e.target;
  (i.picker.active || i.config.showOnClick) && (t._active = ne(t), t._clicking = setTimeout(() => {
    delete t._active, delete t._clicking;
  }, 2e3));
}
function Yt(i, e) {
  const t = e.target;
  t._clicking && (clearTimeout(t._clicking), delete t._clicking, t._active && i.enterEditMode(), delete t._active, i.config.showOnClick && i.show());
}
function Ht(i, e) {
  e.clipboardData.types.includes("text/plain") && i.enterEditMode();
}
function jt(i, e) {
  const { element: t, picker: a } = i;
  if (!a.active && !ne(t))
    return;
  const n = a.element;
  Je(e, (r) => r === t || r === n) || et(i);
}
function at(i, e) {
  return i.map((t) => q(t, e.format, e.locale)).join(e.dateDelimiter);
}
function nt(i, e, t = !1) {
  if (e.length === 0)
    return t ? [] : void 0;
  const { config: a, dates: n, rangeSideIndex: r } = i, { pickLevel: s, maxNumberOfDates: o } = a;
  let d = e.reduce((c, l) => {
    let u = I(l, a.format, a.locale);
    return u === void 0 || (u = $(u, s, r), !ke(u, a.minDate, a.maxDate) || c.includes(u) || a.checkDisabled(u, s) || !(s > 0) && a.daysOfWeekDisabled.includes(new Date(u).getDay()) || c.push(u)), c;
  }, []);
  return d.length !== 0 ? (a.multidate && !t && (d = d.reduce((c, l) => (n.includes(l) || c.push(l), c), n.filter((c) => !d.includes(c)))), o && d.length > o ? d.slice(-1 * o) : d) : void 0;
}
function ae(i, e = 3, t = !0, a = void 0) {
  const { config: n, picker: r, inputField: s } = i;
  if (2 & e) {
    const o = r.active ? n.pickLevel : n.startView;
    r.update(a).changeView(o).render(t);
  }
  1 & e && s && (s.value = at(i.dates, n));
}
function Ve(i, e, t) {
  const a = i.config;
  let { clear: n, render: r, autohide: s, revert: o, forceRefresh: d, viewDate: c } = t;
  r === void 0 && (r = !0), r ? s === void 0 && (s = a.autohide) : s = d = !1, c = I(c, a.format, a.locale);
  const l = nt(i, e, n);
  (l || o) && (l && l.toString() !== i.dates.toString() ? (i.dates = l, ae(i, r ? 3 : 1, !0, c), A(i, "changeDate")) : ae(i, d ? 3 : 1, !0, c), s && i.hide());
}
function Re(i, e) {
  return e ? (t) => q(t, e, i.config.locale) : (t) => new Date(t);
}
class xe {
  constructor(e, t = {}, a = void 0) {
    e.datepicker = this, this.element = e, this.dates = [];
    const n = this.config = Object.assign({ buttonClass: t.buttonClass && String(t.buttonClass) || "button", container: null, defaultViewDate: F(), maxDate: void 0, minDate: void 0 }, de(ye, this));
    let r;
    if (e.tagName === "INPUT" ? (r = this.inputField = e, r.classList.add("datepicker-input"), t.container && (n.container = t.container instanceof HTMLElement ? t.container : document.querySelector(t.container))) : n.container = e, a) {
      const l = a.inputs.indexOf(r), u = a.datepickers;
      if (l < 0 || l > 1 || !Array.isArray(u))
        throw Error("Invalid rangepicker object.");
      u[l] = this, this.rangepicker = a, this.rangeSideIndex = l;
    }
    this._options = t, Object.assign(n, de(t, this)), n.shortcutKeys = function(l) {
      return Object.keys(Oe).reduce((u, w) => {
        const f = l[w] === void 0 ? Oe[w] : l[w], x = f && f.key;
        if (!x || typeof x != "string")
          return u;
        const p = { key: x, ctrlOrMetaKey: !!(f.ctrlOrMetaKey || f.ctrlKey || f.metaKey) };
        return x.length > 1 && (p.altKey = !!f.altKey, p.shiftKey = !!f.shiftKey), u[w] = p, u;
      }, {});
    }(t.shortcutKeys || {});
    const s = _e(e.value || e.dataset.date, n.dateDelimiter);
    delete e.dataset.date;
    const o = nt(this, s);
    o && o.length > 0 && (this.dates = o), r && (r.value = at(this.dates, n));
    const d = this.picker = new Vt(this), c = [e, "keydown", Tt.bind(null, this)];
    r ? te(this, [c, [r, "focus", Wt.bind(null, this)], [r, "mousedown", zt.bind(null, this)], [r, "click", Yt.bind(null, this)], [r, "paste", Ht.bind(null, this)], [document, "mousedown", jt.bind(null, this)], [window, "resize", d.place.bind(d)]]) : (te(this, [c]), this.show());
  }
  static formatDate(e, t, a) {
    return q(e, t, a && W[a] || W.en);
  }
  static parseDate(e, t, a) {
    return I(e, t, a && W[a] || W.en);
  }
  static get locales() {
    return W;
  }
  get active() {
    return !(!this.picker || !this.picker.active);
  }
  get pickerElement() {
    return this.picker ? this.picker.element : void 0;
  }
  setOptions(e) {
    const t = de(e, this);
    Object.assign(this._options, e), Object.assign(this.config, t), this.picker.setOptions(t), ae(this, 3);
  }
  show() {
    if (this.inputField) {
      const { config: e, inputField: t } = this;
      if (t.disabled || t.readOnly && !e.enableOnReadonly)
        return;
      ne(t) || e.disableTouchKeyboard || (this._showing = !0, t.focus(), delete this._showing);
    }
    this.picker.show();
  }
  hide() {
    this.inputField && (this.picker.hide(), this.picker.update().changeView(this.config.startView).render());
  }
  toggle() {
    this.picker.active ? this.inputField && this.picker.hide() : this.show();
  }
  destroy() {
    this.hide(), Ue(this), this.picker.detach();
    const e = this.element;
    return e.classList.remove("datepicker-input"), delete e.datepicker, this;
  }
  getDate(e = void 0) {
    const t = Re(this, e);
    return this.config.multidate ? this.dates.map(t) : this.dates.length > 0 ? t(this.dates[0]) : void 0;
  }
  setDate(...e) {
    const t = [...e], a = {}, n = me(e);
    !n || typeof n != "object" || Array.isArray(n) || n instanceof Date || Object.assign(a, t.pop()), Ve(this, Array.isArray(t[0]) ? t[0] : t, a);
  }
  update(e = void 0) {
    if (!this.inputField)
      return;
    const t = Object.assign(e || {}, { clear: !0, render: !0, viewDate: void 0 });
    Ve(this, _e(this.inputField.value, this.config.dateDelimiter), t);
  }
  getFocusedDate(e = void 0) {
    return Re(this, e)(this.picker.viewDate);
  }
  setFocusedDate(e, t = !1) {
    const { config: a, picker: n, active: r, rangeSideIndex: s } = this, o = a.pickLevel, d = I(e, a.format, a.locale);
    d !== void 0 && (n.changeFocus($(d, o, s)), r && t && n.changeView(o), n.render());
  }
  refresh(e = void 0, t = !1) {
    let a;
    e && typeof e != "string" && (t = e, e = void 0), a = e === "picker" ? 2 : e === "input" ? 1 : 3, ae(this, a, !t);
  }
  enterEditMode() {
    const e = this.inputField;
    e && !e.readOnly && this.picker.active && !this.editMode && (this.editMode = !0, e.classList.add("in-edit"));
  }
  exitEditMode(e = void 0) {
    if (!this.inputField || !this.editMode)
      return;
    const t = Object.assign({ update: !1 }, e);
    delete this.editMode, this.inputField.classList.remove("in-edit"), t.update && this.update(t);
  }
}
function Te(i) {
  const e = Object.assign({}, i);
  return delete e.inputs, delete e.allowOneSidedRange, delete e.maxNumberOfDates, e;
}
function z(i, e) {
  if (i._updating)
    return;
  i._updating = !0;
  const t = e.target;
  if (t.datepicker === void 0)
    return;
  const a = i.datepickers, [n, r] = a, s = { render: !1 }, o = i.inputs.indexOf(t), d = o === 0 ? 1 : 0, c = a[o].dates[0], l = a[d].dates[0];
  c !== void 0 && l !== void 0 ? o === 0 && c > l ? (n.setDate(l, s), r.setDate(c, s)) : o === 1 && c < l && (n.setDate(c, s), r.setDate(l, s)) : i.allowOneSidedRange || c === void 0 && l === void 0 || (s.clear = !0, a[d].setDate(a[o].dates, s)), a.forEach((u) => {
    u.picker.update().render();
  }), delete i._updating;
}
class Kt {
  constructor(e, t = {}) {
    let a = Array.isArray(t.inputs) ? t.inputs : Array.from(e.querySelectorAll("input"));
    if (a.length < 2)
      return;
    e.rangepicker = this, this.element = e, this.inputs = a = a.slice(0, 2), Object.freeze(a), this.allowOneSidedRange = !!t.allowOneSidedRange;
    const n = z.bind(null, this), r = Te(t), s = this.datepickers = [];
    a.forEach((o) => {
      (function(d, c, l, u) {
        te(d, [[l, "changeDate", c]]), new xe(l, u, d);
      })(this, n, o, r);
    }), Object.freeze(s), Object.defineProperty(this, "dates", { get: () => s.map((o) => o.dates[0]) }), s[0].dates.length > 0 ? z(this, { target: a[0] }) : s[1].dates.length > 0 && z(this, { target: a[1] });
  }
  setOptions(e) {
    this.allowOneSidedRange = !!e.allowOneSidedRange;
    const t = Te(e);
    this.datepickers.forEach((a) => {
      a.setOptions(t);
    });
  }
  destroy() {
    this.datepickers.forEach((e) => {
      e.destroy();
    }), Ue(this), delete this.element.rangepicker;
  }
  getDates(e = void 0) {
    const t = e ? (a) => q(a, e, this.datepickers[0].config.locale) : (a) => new Date(a);
    return this.dates.map((a) => a === void 0 ? a : t(a));
  }
  setDates(e, t) {
    const { datepickers: [a, n], inputs: [r, s], dates: [o, d] } = this;
    this._updating = !0, a.setDate(e), n.setDate(t), delete this._updating, n.dates[0] !== d ? z(this, { target: s }) : a.dates[0] !== o && z(this, { target: r });
  }
}
var Ut = Object.defineProperty, qt = Object.getOwnPropertyDescriptor, m = (i, e, t, a) => {
  for (var n, r = a > 1 ? void 0 : a ? qt(e, t) : e, s = i.length - 1; s >= 0; s--)
    (n = i[s]) && (r = (a ? n(e, t, r) : n(r)) || r);
  return a && r && Ut(e, t, r), r;
}, Jt = ((i) => (i.SINGLE_DATE_PICKER = "single", i.DATE_RANGE = "range", i))(Jt || {}), Xt = ((i) => (i.INFO = "info", i.SUCCESS = "success", i.ERROR = "error", i.WARNING = "warning", i))(Xt || {});
const G = { format: "mm/dd/yyyy", prevArrow: `<span class="icon-button-wrapper">
      <ex-icon-button icon="Left caret" flavor="branded" type="tertiary" circular="" size="small" hide-browser-tooltip=""></ex-icon-button>
    </span>`, nextArrow: `<span class="icon-button-wrapper">
      <ex-icon-button icon="Right caret" flavor="branded" type="tertiary" circular="" size="small" hide-browser-tooltip=""></ex-icon-button>
    </span>`, todayButton: !0, todayHighlight: !0, autohide: !0, minDate: "", maxDate: "", container: document.body }, L = { format: "mm/dd/yyyy", prevArrow: `<span class="icon-button-wrapper">
      <ex-icon-button icon="Left caret" flavor="branded" type="tertiary" circular="" size="small" hide-browser-tooltip=""></ex-icon-button>
    </span>`, nextArrow: `<span class="icon-button-wrapper">
      <ex-icon-button icon="Right caret" flavor="branded" type="tertiary" circular="" size="small" hide-browser-tooltip=""></ex-icon-button>
    </span>`, todayButton: !0, todayHighlight: !0, minDate: "", maxDate: "", container: document.body };
xe.locales.en = { days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], daysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], daysMin: ["S", "M", "T", "W", "T", "F", "S"], months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"], monthsShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], today: "Jump to Today", clear: "Clear", titleFormat: "M y", format: "mm/dd/yyyy", weekStart: 0 };
const ue = (i) => i instanceof Date && !Number.isNaN(i.valueOf()), pe = (i, e) => {
  if (e === "dd/mm/yyyy" && i.length) {
    const t = i.split("/");
    return /* @__PURE__ */ new Date(`${t[2]}-${t[1]}-${t[0]}`);
  }
  return new Date(i);
};
class g extends ct {
  constructor() {
    super(...arguments), this.hasFocus = !1, this.slotController = new ht(this, "label", "help-text"), this.label = "", this.helpText = "", this.errorMsg = "", this.required = !1, this.optional = !1, this.invalid = !1, this.disabled = !1, this.readonly = !1, this.clearable = !1, this.value = "", this.startDate = "", this.endDate = "", this.minDate = "", this.maxDate = "", this.type = "single", this.showStatusIcon = !1, this.footerType = "info", this.infoText = "", this.useIconButton = !1, this.tooltipText = "select date", this.statusIconLabel = "", this.open = !1, this.synchronizeUiWithInput = !1, this.showClearButton = !0;
  }
  setDateValueIfPresent() {
    var e, t, a, n;
    if (this.value) {
      let r = pe(this.value, this.format);
      ue(r) || (r = "", this.value = r), this.format ? ((e = this.datePicker) == null ? void 0 : e.getDate()) === void 0 ? (t = this.datePicker) == null || t.setDate(r, { clear: !0 }) : (a = this.datePicker) == null || a.update(r, { clear: !0 }) : (n = this.datePicker) == null || n.setDate(r, { clear: !0 });
    }
  }
  handleEndDateWithFormat(e) {
    var t, a, n;
    ((t = this.datePicker.datepickers[1]) == null ? void 0 : t.getDate()) !== e ? (a = this.datePicker.datepickers[1]) == null || a.setDate(e, { clear: !0 }) : (n = this.datePicker.datepickers[1]) == null || n.update(e, { clear: !0 });
  }
  handleStartDateWithFormat(e) {
    var t, a, n, r;
    ((a = (t = this.datePicker) == null ? void 0 : t.datepickers[0]) == null ? void 0 : a.getDate()) === void 0 ? (n = this.datePicker.datepickers[0]) == null || n.setDate(e, { clear: !0 }) : (r = this.datePicker.datepickers[0]) == null || r.update(e, { clear: !0 });
  }
  setDateRangeValueIfPresent() {
    var e, t, a, n;
    if (this.startDate && ((e = this.datePicker) != null && e.datepickers)) {
      let r = pe(this.startDate, this.format);
      ue(r) || (r = "", this.startDate = r), this.format ? this.handleStartDateWithFormat(r) : (t = this.datePicker.datepickers[0]) == null || t.setDate(r, { clear: !0 });
    }
    if (this.endDate && ((a = this.datePicker) != null && a.datepickers)) {
      let r = pe(this.endDate, this.format);
      ue(r) || (r = "", this.endDate = r), this.format ? this.handleEndDateWithFormat(r) : (n = this.datePicker.datepickers[1]) == null || n.setDate(r, { clear: !0 });
    }
  }
  cancelDateRangePickerUpdate() {
    this.setDateRangeValueIfPresent();
  }
  applyDateRangePickerUpdate() {
    const e = this.datePicker.datepickers[0].getDate(L.format) || "", t = this.datePicker.datepickers[1].getDate(L.format) || "", a = this.datePicker.datepickers[0].getDate() || "", n = this.datePicker.datepickers[1].getDate() || "";
    this.startDate = e, this.endDate = t, this.dispatchOnChangeEvent({ startDate: a, endDate: n });
  }
  hideDateRangePicker() {
    this.datePicker.datepickers[0].hide(), this.datePicker.datepickers[1].hide();
  }
  getDatePickerOptions() {
    return { ...G, format: this.format || "mm/dd/yyyy", clearButton: this.showClearButton };
  }
  getDateRangePickerOptions() {
    return { ...L, format: this.format || "mm/dd/yyyy", clearButton: this.showClearButton };
  }
  setDateRangeminDate() {
    L.minDate = this.minDate;
  }
  setDateRangemaxDate() {
    L.maxDate = this.maxDate;
  }
  dateRangePickerMinMax() {
    this.minDate = this.minDate ? this.setDateRangeminDate() : "", this.maxDate = this.maxDate ? this.setDateRangemaxDate() : "";
  }
  setDatePickerminDate() {
    G.minDate = this.minDate;
  }
  setDatePickermaxDate() {
    G.maxDate = this.maxDate;
  }
  datePickerMinMax() {
    this.minDate = this.minDate ? this.setDatePickerminDate() : "", this.maxDate = this.maxDate ? this.setDatePickermaxDate() : "";
  }
  openDatePickerIfNeeded() {
    this.datePicker && this.open && (this.type === "range" ? this.datePicker.datepickers[0].show() : this.datePicker.show());
  }
  closeDatePickerIfNeeded() {
    this.datePicker && (this.type === "range" ? this.hideDateRangePicker() : this.hideDatePicker());
  }
  async firstUpdated() {
    const e = await this.dateInputEle;
    if (this.type === "range") {
      const t = e.querySelector("#datepicker-input-start"), a = e.querySelector("#datepicker-input-end");
      this.datePicker = new Kt(e, this.getDateRangePickerOptions()), this.datePicker.datepickers[0].pickerElement.classList.add("exo-datepicker"), this.datePicker.datepickers[1].pickerElement.classList.add("exo-datepicker"), this.dateRangePickerMinMax(), this.datePicker.setOptions({ ...L, format: this.format || "mm/dd/yyyy" }), this.format && (t == null || t.setAttribute("placeholder", this.format), a == null || a.setAttribute("placeholder", this.format));
    } else
      this.datePickerMinMax(), this.datePicker = new xe(e, this.getDatePickerOptions()), this.datePicker.pickerElement.classList.add("exo-datepicker"), this.format && e.setAttribute("placeholder", this.format);
    this.addEventListeners(), this.setDateValueIfPresent(), this.setDateRangeValueIfPresent(), this.openDatePickerIfNeeded();
  }
  getDatePickerInputElement() {
    return this.datePicker.element || null;
  }
  getDatePickerInputElements() {
    return this.datePicker.inputs || null;
  }
  dispatchOnChangeEvent(e) {
    this.dispatchCustomEvent("on-change", e);
  }
  handleDateChange(e) {
    var t, a;
    if (this.type === "single") {
      let n;
      n = this.format ? (t = this.datePicker) == null ? void 0 : t.getDate(this.format) : (a = this.datePicker) == null ? void 0 : a.getDate(G.format), n || (n = ""), this.value = n, this.dispatchOnChangeEvent({ date: e.detail.date || "", formattedDate: n });
    } else {
      const n = this.datePicker.datepickers[0].pickerElement, r = this.datePicker.datepickers[1].pickerElement;
      n == null || n.querySelectorAll(".date-range-picker__button-apply").forEach((d) => {
        d.removeAttribute("disabled");
      }), r == null || r.querySelectorAll(".date-range-picker__button-apply").forEach((d) => {
        d.removeAttribute("disabled");
      });
      const s = n.querySelector(".datepicker-cell.day.range-start.selected:not(.datepicker-cell.day.range-start.selected.focused)"), o = r.querySelector(".datepicker-cell.day.range-end.selected:not(.datepicker-cell.day.range-start.range-end.selected.focused)");
      s === null && o && (this.applyDateRangePickerUpdate(), this.hideDateRangePicker());
    }
  }
  handleDatePickerHide() {
    this.dispatchCustomEvent("on-close", {});
  }
  addEventListeners() {
    if (this.type === "single") {
      const e = this.getDatePickerInputElement();
      e && (e.addEventListener("changeDate", this.handleDateChange.bind(this)), e.addEventListener("hide", this.handleDatePickerHide.bind(this)));
    } else {
      const e = this.getDatePickerInputElements();
      e && e.length === 2 && e.forEach((t) => {
        t.addEventListener("changeDate", this.handleDateChange.bind(this)), t.addEventListener("hide", this.handleDatePickerHide.bind(this));
      });
    }
  }
  removeEventListeners() {
    if (this.type === "single") {
      const e = this.getDatePickerInputElement();
      e && (e.removeEventListener("changeDate", this.handleDateChange.bind(this)), e.removeEventListener("hide", this.handleDatePickerHide.bind(this)));
    } else {
      const e = this.getDatePickerInputElements();
      e && e.length === 2 && e.forEach((t) => {
        t.removeEventListener("changeDate", this.handleDateChange.bind(this)), t.removeEventListener("hide", this.handleDatePickerHide.bind(this));
      });
    }
  }
  destroy() {
    this.type === "single" ? (this.datePicker.hide(), this.removeEventListeners(), this.datePicker.picker.detach()) : (this.datePicker.datepickers[0].hide(), this.datePicker.datepickers[1].hide(), this.removeEventListeners(), this.datePicker.rangepicker.detach());
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.removeEventListeners(), this.datePicker.destroy();
  }
  renderAdditionalLabelText() {
    return this.required ? y`<span class="form-control__additional-text">
        (required)
      </span>` : this.optional ? y`<span class="form-control__additional-text">
        (optional)
      </span>` : T;
  }
  renderHelpText() {
    return this.helpText ? y`<div class="form-control__help-text">
        ${this.setStatusIcon()}${this.helpText}
      </div>` : y`${T}`;
  }
  renderInvalidAndErrorMsg() {
    const e = this.invalid ? "false" : "true";
    return this.invalid && this.errorMsg ? y`<div
        part="form-control-invalid-text"
        id="invalid-text"
        class="form-control__invalid-text"
        aria-invalid=${e}
        aria-live="polite"
      >
        <ex-icon
          class="error-icon"
          size="XS"
          icon="circle-warning"
          variant="danger"
        ></ex-icon>
        <slot name="error-text">${this.errorMsg}</slot>
      </div>` : y`${T}`;
  }
  renderHelpAndValidationText() {
    const e = this.slotController.test("help-text"), t = !!this.helpText || !!e, a = this.invalid ? this.renderInvalidAndErrorMsg() : this.renderHelpText();
    return y` <div
      part="form-control-help-text"
      id="help-text"
      class="form-control__info-error-texts"
      aria-hidden=${t ? "false" : "true"}
    >
      <div class="date-picker__footer-${this.footerType}">${a}</div>
    </div>`;
  }
  handleBlur() {
    this.hasFocus = !1;
  }
  setInputContainerClass() {
    return M({ input__control: !0, "synchronize-ui-with-input": this.synchronizeUiWithInput });
  }
  setInputFormControlClass() {
    return M({ "form-control__label": !0, "synchronize-ui-with-input": this.synchronizeUiWithInput });
  }
  handleFocus() {
    this.hasFocus = !0;
  }
  async toggleDatePicker() {
    if (this.type === "single")
      this.datePicker.toggle();
    else {
      const e = (await this.dateInputEle).querySelector("#datepicker-input-start");
      e && e.focus();
    }
  }
  hideDatePicker() {
    this.datePicker.hide();
  }
  calenderIconClickHandler() {
    this.disabled || this.toggleDatePicker();
  }
  setStatusIcon() {
    if (this.showStatusIcon)
      switch (this.footerType) {
        case "success":
          return y`<ex-icon
            size="XS"
            icon="Success"
            label=${this.statusIconLabel}
          ></ex-icon>`;
        case "error":
          return y`<ex-icon
            size="XS"
            icon="Error"
            label=${this.statusIconLabel}
          ></ex-icon>`;
        case "warning":
          return y`<ex-icon
            size="XS"
            icon="Warning"
            label=${this.statusIconLabel}
          ></ex-icon>`;
        default:
          return y`<ex-icon
            size="XS"
            icon="Information"
            label=${this.statusIconLabel}
          ></ex-icon>`;
      }
    return T;
  }
  getInfoText() {
    return this.infoText ? y`
        <ex-icon-button
          class="form-control__label-info-icon"
          icon="information"
          flavor="branded"
          hide-browser-tooltip=""
          type="tertiary"
          tooltipText=${this.infoText}
          size="x-small"
          circular=""
        ></ex-icon-button>
      ` : T;
  }
  handleClearClick(e) {
    this.datePicker.setDate({ clear: !0 });
    const t = this.getDatePickerInputElement();
    t && t.focus(), e.stopPropagation();
  }
  handleRangeClearClick(e) {
    this.datePicker.datepickers[0].setDate({ clear: !0 }), this.datePicker.datepickers[1].setDate({ clear: !0 });
    const t = this.getDatePickerInputElement();
    t && t.focus(), e.stopPropagation();
  }
  update(e) {
    var t, a;
    super.update(e), e.has("disabled") && e.get("disabled") !== this.disabled && this.hasUpdated && this.closeDatePickerIfNeeded(), this.type === "single" && e.has("value") && e.get("value") !== this.value && this.hasUpdated && this.setDateValueIfPresent(), e.has("open") && e.get("open") !== this.open && this.hasUpdated && (this.open ? this.openDatePickerIfNeeded() : this.closeDatePickerIfNeeded()), e.has("showClearButton") && this.hasUpdated && (this.type === "range" ? (t = this.datePicker) == null || t.setOptions(this.getDateRangePickerOptions()) : (a = this.datePicker) == null || a.setOptions(this.getDatePickerOptions()));
  }
  getSingleDatePill() {
    return this.value ? y` <ex-pill
          interactive=""
          removable=""
          color="blue"
          class="icon-calender__pill"
          @onRemove=${this.handleClearClick}
          >${this.value}</ex-pill
        >` : "";
  }
  getSingleIconButton() {
    return y`<div class="form-control__input-icon-button">
        <div part="input--container">
          <input
            id="datepicker-input"
            class="input__control-icon"
            part="input--element"
            tabindex="-1"
            @focus=${this.handleFocus}
          />
        </div>
      </div>
      ${this.readonly ? "" : y`
            <span class="input__suffix-icon-calender" part="input__suffix">
              <ex-icon-button
                class=${M({ "input__suffix-icon": !0 })}
                icon="Calendar"
                label="calendar icon"
                flavor="branded"
                type="secondary"
                size="default"
                ?disabled=${this.disabled}
                tooltiptext=${this.tooltipText}
                @click=${this.calenderIconClickHandler}
              ></ex-icon-button>
            </span>
            ${this.getSingleDatePill()}
          `}`;
  }
  getSingleDatePickerInput(e, t) {
    const a = t ? "Close" : "Calendar", n = t ? "clear" : "calendar icon", r = t ? this.handleClearClick : this.calenderIconClickHandler;
    return y`
      <label
        class=${this.setInputFormControlClass()}
        for="datepicker-input"
        aria-hidden=${e ? "false" : "true"}
      >
        <slot name="label"> ${this.label} </slot>
        ${this.getInfoText()} ${this.renderAdditionalLabelText()}
      </label>
      <div class="form-control__input">
        <div
          class=${M({ input: !0, "input--disabled": this.disabled, "input--invalid": this.invalid, "input--focused": this.hasFocus, "input--readonly": this.readonly, "synchronize-ui-with-input": this.synchronizeUiWithInput })}
          part="input--container"
        >
          <input
            type="text"
            id="datepicker-input"
            class=${this.setInputContainerClass()}
            part="input--element"
            value=${this.value}
            name=${lt(this.name)}
            placeholder=${this.placeholder}
            @focus=${this.handleFocus}
            @blur=${this.handleBlur}
            ?disabled=${this.disabled}
            ?readonly=${this.readonly}
          />
          ${this.readonly ? "" : y`
                <span class="input__suffix" part="input__suffix">
                  <ex-icon-button
                    class=${M({ "input__suffix-icon": !0, "input__suffix-icon--disabled": this.disabled })}
                    icon=${a}
                    label=${n}
                    flavor="branded"
                    type="tertiary"
                    size="small"
                    @click=${r}
                  ></ex-icon-button>
                </span>
              `}
        </div>
      </div>
      ${this.renderHelpAndValidationText()}
    `;
  }
  getSingleDatePicker(e) {
    const { hasLabel: t, hasClearIcon: a } = e[0];
    return y`
      <div
        class=${M({ "form-control": !0, "form-control--has-label": t, "input--readonly": this.readonly, "form-control--icon-button": this.useIconButton })}
      >
        ${this.useIconButton ? this.getSingleIconButton() : this.getSingleDatePickerInput(t, a)}
      </div>
    `;
  }
  getRangeDatePill() {
    return this.startDate ? y` <ex-pill
          interactive=""
          removable=""
          color="blue"
          class=${M({ "icon-calender__pill": !0, "date-range-picker": !0 })}
          @onRemove=${this.handleRangeClearClick}
          >${this.startDate} - ${this.endDate}
        </ex-pill>` : "";
  }
  getRangeIconButton() {
    return y` ${this.readonly ? "" : y`
          <span
            class=${M({ "input__suffix-icon-calender": !0, "date-range-picker": !0 })}
            part="input__suffix"
          >
            <ex-icon-button
              class="input__suffix-icon"
              icon="Calendar"
              label="calendar icon"
              flavor="branded"
              type="secondary"
              size="default"
              ?disabled=${this.disabled}
              tooltiptext=${this.tooltipText}
              @click=${this.calenderIconClickHandler}
            ></ex-icon-button>
          </span>
          ${this.getRangeDatePill()}
        `}`;
  }
  getRangeDatePickerIcon() {
    return y`
      <div
        id="datepicker-input"
        part="input--container"
        class="date-range-input-icon"
      >
        <input
          id="datepicker-input-start"
          name="range-start"
          ?disabled=${this.disabled}
          tabindex="-1"
          class="icon-datepicker-input-start"
        />
        <input
          id="datepicker-input-end"
          name="range-end"
          ?disabled=${this.disabled}
          tabindex="-1"
          class="icon-datepicker-input-end"
        />
      </div>
      ${this.getRangeIconButton()}
    `;
  }
  getRangeDatePickerInput(e) {
    const { hasLabel: t } = e[0];
    return y`
      <div
        class=${M({ "form-control": !0, "date-range-picker": !0, "form-control--has-label": t, "input--readonly": this.readonly })}
      >
        <label
          class=${this.setInputFormControlClass()}
          for="datepicker-input"
          aria-hidden=${t ? "false" : "true"}
        >
          <slot name="label"> ${this.label} </slot>
          ${this.getInfoText()} ${this.renderAdditionalLabelText()}
        </label>
        <div class="form-control__input">
          <div
            id="datepicker-input"
            class=${M({ input: !0, "input--disabled": this.disabled, "input--invalid": this.invalid, "input--focused": this.hasFocus, "input--readonly": this.readonly, "synchronize-ui-with-input": this.synchronizeUiWithInput })}
            part="input--container"
          >
            <input
              type="text"
              id="datepicker-input-start"
              class=${this.setInputContainerClass()}
              part="input--element"
              name="range-start"
              value=${this.startDate}
              placeholder=${this.placeholder}
              @focus=${this.handleFocus}
              @blur=${this.handleBlur}
              ?disabled=${this.disabled}
            />
            ${this.readonly ? "-" : y`<span class="date-range-picker__input-seperator"></span>`}
            <input
              type="text"
              id="datepicker-input-end"
              class=${this.setInputContainerClass()}
              part="input--element"
              name="range-end"
              value=${this.endDate}
              placeholder=${this.placeholder}
              @focus=${this.handleFocus}
              @blur=${this.handleBlur}
              ?disabled=${this.disabled}
            />
          </div>
        </div>
        ${this.renderHelpAndValidationText()}
      </div>
      ${this.useIconButton ? this.getRangeDatePickerIcon() : ""}
    </div>
    `;
  }
  getRangeDatePicker(e) {
    return this.useIconButton ? this.getRangeDatePickerIcon() : this.getRangeDatePickerInput(e);
  }
  getDatePicker(...e) {
    let t;
    return t = this.type === "single" ? this.getSingleDatePicker(e) : this.getRangeDatePicker(e), t;
  }
  render() {
    const e = this.slotController.test("label"), t = !!this.label || !!e, a = this.clearable && !this.disabled && this.value.length > 0;
    return this.getDatePicker({ hasLabel: t, hasClearIcon: a });
  }
}
g.styles = [we(`.datepicker{width:-moz-min-content;width:min-content}.datepicker:not(.active){display:none}.datepicker-dropdown{position:absolute;z-index:20;padding-top:4px}.datepicker-dropdown.datepicker-orient-top{padding-top:0;padding-bottom:4px}.datepicker-picker{display:flex;flex-direction:column;border-radius:4px;background-color:#fff}.datepicker-dropdown .datepicker-picker{box-shadow:0 2px 3px #0a0a0a1a,0 0 0 1px #0a0a0a1a}.datepicker-main{flex:auto;padding:2px}.datepicker-footer{box-shadow:inset 0 1px 1px #0a0a0a1a;background-color:#f5f5f5}.datepicker-title{box-shadow:inset 0 -1px 1px #0a0a0a1a;background-color:#f5f5f5;padding:.375rem .75rem;text-align:center;font-weight:700}.datepicker-controls{display:flex}.datepicker-header .datepicker-controls{padding:2px 2px 0}.datepicker-controls .button{display:inline-flex;position:relative;align-items:center;justify-content:center;margin:0;border:1px solid gainsboro;border-radius:4px;box-shadow:none;background-color:#fff;cursor:pointer;padding:calc(.375em - 1px) .75em;height:2.25em;vertical-align:top;text-align:center;line-height:1.5;white-space:nowrap;color:#363636;font-size:1rem}.datepicker-controls .button:focus,.datepicker-controls .button:active{outline:none}.datepicker-controls .button:hover{border-color:#b8b8b8;color:#363636}.datepicker-controls .button:focus{border-color:#3273dc;color:#363636}.datepicker-controls .button:focus:not(:active){box-shadow:0 0 0 .125em #3273dc40}.datepicker-controls .button:active{border-color:#474747;color:#363636}.datepicker-controls .button[disabled]{cursor:not-allowed}.datepicker-header .datepicker-controls .button{border-color:transparent;font-weight:700}.datepicker-header .datepicker-controls .button:hover{background-color:#f9f9f9}.datepicker-header .datepicker-controls .button:active{background-color:#f2f2f2}.datepicker-footer .datepicker-controls .button{flex:auto;margin:calc(.375rem - 1px) .375rem;border-radius:2px;font-size:.75rem}.datepicker-controls .view-switch{flex:auto}.datepicker-controls .prev-button,.datepicker-controls .next-button{padding-right:.375rem;padding-left:.375rem;flex:0 0 14.2857142857%}.datepicker-controls .prev-button.disabled,.datepicker-controls .next-button.disabled{visibility:hidden}.datepicker-view,.datepicker-grid{display:flex}.datepicker-view{align-items:stretch;width:15.75rem}.datepicker-grid{flex-wrap:wrap;flex:auto}.datepicker .days{display:flex;flex-direction:column;flex:auto}.datepicker .days-of-week{display:flex}.datepicker .week-numbers{display:flex;flex-direction:column;flex:0 0 9.6774193548%}.datepicker .weeks{display:flex;flex-direction:column;align-items:stretch;flex:auto}.datepicker span{display:flex;align-items:center;justify-content:center;border-radius:4px;cursor:default;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;user-select:none}.datepicker .dow{height:1.5rem;font-size:.875rem;font-weight:700}.datepicker .week{flex:auto;color:#b8b8b8;font-size:.75rem}.datepicker-cell,.datepicker .days .dow{flex-basis:14.2857142857%}.datepicker-cell{height:2.25rem}.datepicker-cell:not(.day){flex-basis:25%;height:4.5rem}.datepicker-cell:not(.disabled):hover{background-color:#f9f9f9;cursor:pointer}.datepicker-cell.focused:not(.selected){background-color:#e9e9e9}.datepicker-cell.selected,.datepicker-cell.selected:hover{background-color:#3273dc;color:#fff;font-weight:600}.datepicker-cell.disabled{color:#dcdcdc}.datepicker-cell.prev:not(.disabled),.datepicker-cell.next:not(.disabled){color:#7a7a7a}.datepicker-cell.prev.selected,.datepicker-cell.next.selected{color:#e6e6e6}.datepicker-cell.highlighted:not(.selected):not(.range):not(.today){border-radius:0;background-color:#f5f5f5}.datepicker-cell.highlighted:not(.selected):not(.range):not(.today):not(.disabled):hover{background-color:#efefef}.datepicker-cell.highlighted:not(.selected):not(.range):not(.today).focused{background-color:#e9e9e9}.datepicker-cell.today:not(.selected){background-color:#00d1b2}.datepicker-cell.today:not(.selected):not(.disabled){color:#fff}.datepicker-cell.today.focused:not(.selected){background-color:#00ccad}.datepicker-cell.range-end:not(.selected),.datepicker-cell.range-start:not(.selected){background-color:#b8b8b8;color:#fff}.datepicker-cell.range-end.focused:not(.selected),.datepicker-cell.range-start.focused:not(.selected){background-color:#b3b3b3}.datepicker-cell.range-start:not(.range-end){border-radius:4px 0 0 4px}.datepicker-cell.range-end:not(.range-start){border-radius:0 4px 4px 0}.datepicker-cell.range{border-radius:0;background-color:#dcdcdc}.datepicker-cell.range:not(.disabled):not(.focused):not(.today):hover{background-color:#d7d7d7}.datepicker-cell.range.disabled{color:#c6c6c6}.datepicker-cell.range.focused{background-color:#d1d1d1}.datepicker-input.in-edit{border-color:#276bda}.datepicker-input.in-edit:focus,.datepicker-input.in-edit:active{box-shadow:0 0 .25em .25em #276bda33}
`), ot`
      ${we(`:host{display:block;box-sizing:border-box;--exo-component-date-picker-margin-bottom: var(--exo-spacing-medium)}:host *,:host *:before,:host *:after{box-sizing:border-box}:host .form-control{position:relative;margin-bottom:var(--exo-component-date-picker-margin-bottom)}:host .form-control .form-control__label{display:none}:host .form-control--has-label .form-control__label{display:inline-flex;align-items:center;gap:var(--exo-spacing-2x-small);font:var(--exo-text-label-micro);color:var(--exo-color-font);margin-bottom:var(--exo-spacing-2x-small)}:host .form-control--has-label .form-control__label>.form-control__additional-text{color:var(--exo-color-font-secondary);margin-left:var(--exo-spacing-2x-small)}:host .form-control--has-label .form-control__label.synchronize-ui-with-input>.form-control__additional-text{margin-left:var(--exo-spacing-none)}:host .form-control__info-error-texts,:host .form-control__invalid-text{display:flex;align-items:flex-start;gap:var(--exo-spacing-2x-small);font:var(--exo-text-label-micro);color:var(--exo-color-font-secondary)}:host .form-control__info-error-texts{margin-top:var(--exo-spacing-2x-small)}:host .form-control__help-text{display:flex;gap:var(--exo-spacing-2x-small);margin-bottom:var(--exo-spacing-2x-small);align-items:center}:host .form-control__invalid-text{color:var(--exo-color-font-danger);padding:var(--exo-spacing-2x-small) var(--exo-spacing-4x-small) var(--exo-spacing-none) var(--exo-spacing-4x-small)}:host .input{display:inline-flex;align-items:stretch;justify-content:start;position:relative;width:100%;vertical-align:middle;cursor:text;background-color:var(--exo-color-background);outline:var(--exo-spacing-4x-small) solid var(--exo-color-border-secondary);border-radius:var(--exo-spacing-2x-small);font:var(--exo-text-label-standard);height:var(--exo-spacing-x-large)}:host .input.synchronize-ui-with-input{border:var(--exo-spacing-4x-small) solid var(--exo-color-border-secondary);outline:none}:host .input.synchronize-ui-with-input:hover:not(.input--disabled,.input--invalid,.input--readonly){border:var(--exo-spacing-4x-small) solid var(--exo-color-background-action-hover);outline:none}:host .input:hover:not(.input--disabled,.input--invalid,.input--readonly){outline:var(--exo-spacing-4x-small) solid var(--exo-color-background-action-hover)}:host .input.input--readonly ::selection{background:none}:host .input.synchronize-ui-with-input.input--focused:not(.input--disabled,.input--invalid,.input--readonly){outline:var(--exo-spacing-4x-small) solid var(--exo-color-background-selected);border:var(--exo-spacing-4x-small) solid var(--exo-color-background-selected)}:host .input.input--focused:not(.input--disabled,.input--invalid,.input--readonly){outline:var(--exo-spacing-3x-small) solid var(--exo-color-background-selected)}:host .input.input--readonly,:host .form-control .input.input--readonly:hover{border:var(--exo-spacing-4x-small) solid transparent;outline:none;pointer-events:none;cursor:default;padding:var(--exo-spacing-2x-small) var(--exo-spacing-3x-small)}:host .input--readonly .form-control__label{color:var(--exo-color-font-secondary)}:host .input.input--disabled{background-color:var(--exo-color-background-disabled);border-color:var(--exo-color-border-secondary);opacity:var(--exo-opacity-4);cursor:not-allowed}:host .input.input--disabled .input__control{color:var(--exo-color-font-disabled)}:host .input.input--invalid{outline:var(--exo-spacing-4x-small) solid var(--exo-color-border-danger-strong);background:var(--exo-color-background-danger-weak)}:host .input.input--invalid ::selection{background:var(--exo-color-background-danger-weak)}:host .input.input--focused.input--invalid{background:var(--exo-color-page);outline:var(--exo-spacing-3x-small) solid var(--exo-color-border-danger-strong)}:host .input__control{flex:1 1 auto;font-family:inherit;font-size:inherit;font-weight:inherit;min-width:var(--exo-spacing-none);padding:var(--exo-spacing-2x-small) var(--exo-spacing-2x-small) var(--exo-spacing-2x-small) var(--exo-spacing-x-small);width:var(--exo-size-2);height:100%;color:var(--exo-color-font);border:none;background:none;box-shadow:none;margin:var(--exo-spacing-none);cursor:inherit}:host .input__control:focus{outline:none}:host .input__control::placeholder{color:var(--exo-color-font-secondary);font-style:italic;-webkit-user-select:none;-ms-user-select:none;user-select:none}:host .input__control.synchronize-ui-with-input::placeholder{font-style:normal;color:var(--exo-color-background-deselected)}:host .input .input__suffix{display:inline-flex;align-items:center;justify-content:center;font-size:var(--exo-font-size-x-large);margin-right:var(--exo-spacing-2x-small)}:host .input .input__suffix .input__suffix-icon{cursor:pointer}:host .input .input__suffix .input__suffix-icon.input__suffix-icon--disabled{cursor:not-allowed}:host .datepicker-input.in-edit{border-color:transparent}:host .datepicker-input.in-edit:focus,:host .datepicker-input.in-edit:active{box-shadow:none}:host .date-range-picker .input{align-items:center;width:320px}:host #datepicker-input span.date-range-picker__input-seperator{border-right:var(--exo-spacing-4x-small) solid var(--exo-color-border-secondary);height:var(--exo-spacing-large)}:host .date-picker__footer-info{color:var(--exo-color-background-info-strong)}:host .date-picker__footer-success{color:var(--exo-color-background-success-strong)}:host .date-picker__footer-error{color:var(--exo-color-background-danger-strong)}:host .date-picker__footer-warning{color:var(--exo-color-background-warning-strong)}:host .input__control-icon{width:32px;padding:5px}:host .form-control--icon-button{display:flex}:host .input__suffix-icon-calender{position:absolute}:host .form-control__input-icon-button{width:32px;height:32px;opacity:0}:host .icon-calender__pill{margin-left:8px}:host .date-range-input-icon{opacity:0;width:0;height:0}:host .icon-datepicker-input-start{width:32px;height:32px}:host .icon-calender__pill.date-range-picker{margin-left:40px;position:absolute}:host .icon-datepicker-input-end{scale:0}
`)}
    `], m([st("#datepicker-input")], g.prototype, "dateInputEle", 2), m([rt()], g.prototype, "hasFocus", 2), m([k()], g.prototype, "label", 2), m([k()], g.prototype, "name", 2), m([k({ attribute: "help-text" })], g.prototype, "helpText", 2), m([k({ attribute: "error-msg" })], g.prototype, "errorMsg", 2), m([k({ type: Boolean, reflect: !0 })], g.prototype, "required", 2), m([k({ type: Boolean })], g.prototype, "optional", 2), m([k({ type: Boolean, reflect: !0 })], g.prototype, "invalid", 2), m([k({ type: Boolean, reflect: !0 })], g.prototype, "disabled", 2), m([k({ type: Boolean, reflect: !0 })], g.prototype, "readonly", 2), m([k()], g.prototype, "placeholder", 2), m([k({ type: Boolean })], g.prototype, "clearable", 2), m([k()], g.prototype, "value", 2), m([k({ attribute: "start-date" })], g.prototype, "startDate", 2), m([k({ attribute: "end-date" })], g.prototype, "endDate", 2), m([k({ attribute: "min-date" })], g.prototype, "minDate", 2), m([k({ attribute: "max-date" })], g.prototype, "maxDate", 2), m([k()], g.prototype, "type", 2), m([k({ type: Boolean, reflect: !0 })], g.prototype, "showStatusIcon", 2), m([k()], g.prototype, "footerType", 2), m([k({ attribute: "info-text" })], g.prototype, "infoText", 2), m([k({ type: Boolean })], g.prototype, "useIconButton", 2), m([k()], g.prototype, "tooltipText", 2), m([k({ type: String })], g.prototype, "statusIconLabel", 2), m([k({ type: Boolean, reflect: !0 })], g.prototype, "open", 2), m([k({ reflect: !0 })], g.prototype, "format", 2), m([k({ attribute: "synchronize-ui-with-input", type: Boolean })], g.prototype, "synchronizeUiWithInput", 2), m([k({ type: Boolean })], g.prototype, "showClearButton", 2);
const li = (i = "") => {
  dt("ex-date-picker", g, i), ut(i), pt(i), ft(i), gt(i), mt(i), kt(i);
};
export {
  Jt as D,
  Xt as a,
  g as b,
  li as r
};
